import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {Router} from '@angular/router';
import {take} from 'rxjs/operators';
import {AngularFireDatabase} from '@angular/fire/database';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  @Output()
  close: EventEmitter<any> = new EventEmitter();
  isAdmin = false;
  constructor(public firebaseAuth: AngularFireAuth, private router: Router, private db: AngularFireDatabase) { }

  ngOnInit() {
    this.firebaseAuth.authState.pipe(take(1)).subscribe(auth => {
      if (auth) {
        this.db.object(`users/${auth.uid}`).valueChanges().subscribe((res: any) => {
          if (res.isAdmin) {
            this.isAdmin = true;
          } else {
            this.isAdmin = false;
          }
        });
      }
    });
  }
  logout() {
    this.firebaseAuth.auth.signOut().then((res) => {
      this.router.navigate(['/']);
    });
  }

  goTo(place) {
    this.router.navigate([place]).then(res => this.close.emit());
  }

}
